import { Component, inject, OnInit, signal } from '@angular/core';
import { CalAngularService } from '@cvx/cal-angular';
import { of, catchError, Observable, map } from 'rxjs';
import { GraphService } from '@share/services/graph.service';
import { RouterLink, RouterLinkActive } from '@angular/router';



@Component({
    selector: 'app-header',
    templateUrl: './header.html',
    styleUrl: './header.css',
    imports: [
        RouterLink,
        RouterLinkActive
    ],
})
export class Header implements OnInit {

  // Injects
  private readonly calService = inject(CalAngularService);
  private readonly graphService = inject(GraphService);

  // Signals
  userInitials = signal('');
  userPhotoUrl = signal<string | null>(null);


  ngOnInit(): void {

    this.calService.isUserSignedIn().subscribe((isSignedIn) => {
      if (isSignedIn) {        
        this.setUserAvatar();
      }
    });
  }


  /**
   * Sets the user avatar if a profile photo is available.
   * Otherwise, sets the user's initials.
   */
  private setUserAvatar(): void {

    this.graphService.getProfilePicture().subscribe((photo: Blob | null) => {

      // If we have the profile photo, use it
      if (!!photo) {
        const photoUrl = URL.createObjectURL(photo);
        this.userPhotoUrl.set(photoUrl);
        return;
      }

      // else, display the user's initials
      this.getUserInitials().subscribe(initials => {
        this.userInitials.set(initials);
      });
    });
  }


  /**
   * Retrieves the user's first and last name from Microsoft Graph.
   * @returns Observable emitting the user's initials as a string.
   */
  private getUserInitials(): Observable<string> {

    const fallbackCharacter = "?";

    return this.calService.getUserPropertiesFromMsGraph(['givenName', 'surname'])
      .pipe(
        map((result) => {
          const firstLetter = result?.givenName?.[0] || fallbackCharacter;
          const secondLetter = result?.surname?.[0] || fallbackCharacter;          
          return `${firstLetter}${secondLetter}`;
        }),
        catchError(e => {
          console.error(`Failed to retrieve user name from graph.`, e);
          return of(`${fallbackCharacter}${fallbackCharacter}`);
        })
      );      
  }

}
